<a (click)="click()">
  <img [src]="ActiveImage" *ngIf="Model">
  <img [src]="InactiveImage" *ngIf="!Model">
</a>